/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */

import {connect} from 'react-redux';
import classNames from 'classnames';

import {toggleFavourite} from 'topmeteo/loc/actionCreators';

const LocationManagerFavoriteToggle = ({isFavourite, onToggle}) => (
    <strong className={classNames('control mark-favorite icon-favourite', {none: !isFavourite})} onClick={onToggle} />
);

const mapDispatchToProps = (dispatch, {location}) => ({
    onToggle: () => dispatch(toggleFavourite(location)),
});

export default connect(null, mapDispatchToProps)(LocationManagerFavoriteToggle);
